import axios from '../helpers/axios'
import { logError } from '../services';
import {
  IStandardFeatureList,
  IResponse,
  IDropdownResponse,
  IStandardFeatureDetail,
  IStandardFeaturePayload
} from '../models';

export const getStandardFeaturesList = async (filters?: {
  name?: string;
  optionSetId?: number;
  phaseId?: number;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number | string;
}): Promise<IResponse<IStandardFeatureList[]>> => {
  try {
    const { data } = await axios.get(`/api/standard-features`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getStandardFeaturesList failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createStandardFeature = async (
  standardFeature: IStandardFeaturePayload
): Promise<number> => {
  try {
    const { data } = await axios.post(`/api/standard-features`, standardFeature);
    return data;
  } catch (error) {
    logError(error, 'createStandardFeature failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getStandardFeatureDetail = async (
  standardFeatureId: string
): Promise<IStandardFeatureDetail> => {
  try {
    const { data } = await axios.get(`/api/standard-features/${standardFeatureId}`);
    return data;
  } catch (error) {
    logError(error, 'getStandardFeatureDetail failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateStandardFeatureDetail = async (
  standardFeatureId: string,
  payload: IStandardFeaturePayload
): Promise<IStandardFeatureDetail> => {
  try {
    const { data } = await axios.put(`/api/standard-features/${standardFeatureId}`, payload);
    return data;
  } catch (error) {
    logError(error, 'updateStandardFeatureDetail failed');
    return Promise.reject(error?.response?.data);
  }
};

export const deleteStandardFeature = async (standardFeatureId: string): Promise<void> => {
  try {
    const { data } = await axios.delete(`/api/standard-features/${standardFeatureId}`);
    return data;
  } catch (error) {
    logError(error, 'deleteStandardFeature failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateStandardFeatureImage = async (
  standardFeatureId: string | number,
  imagePost: FormData
): Promise<string[]> => {
  try {
    const { data } = await axios.put(
      `/api/standard-features/image/${standardFeatureId}`,
      imagePost
    );
    return data;
  } catch (error) {
    logError({ error, payload: imagePost }, 'updateStandardFeatureImage failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getStandardFeatureOptionSets = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/standard-features/lookups/option-sets`);
    return data;
  } catch (error) {
    logError(error, 'getStandardFeatureOptionSets failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getStandardFeaturelookup = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/standard-features/lookups/standard-features`);
    return data;
  } catch (error) {
    logError(error, 'getStandardFeaturelookup failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getStandardFeatureBuildOptions = async (): Promise<any> => {
  try {
    const { data } = await axios.get('/api/standard-features/build-options');
    return data;
  } catch (error) {
    logError(error, 'getStandardFeatureBuildOptions failed');
    return Promise.reject(error?.response?.data);
  }
};
